import { render, staticRenderFns } from "./CategComponent.vue?vue&type=template&id=43ffcad6&scoped=true&"
import script from "./CategComponent.vue?vue&type=script&lang=js&"
export * from "./CategComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffcad6",
  null
  
)

export default component.exports